import React, { useState } from 'react';
import SkillDetailsModal from './SkillDetailsModal';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const SkillChecklistComponent = ({ skills, category, playerId, onSkillUpdated }) => {
  const [selectedSkill, setSelectedSkill] = useState(null);

  const openSkillModal = (skill) => {
    setSelectedSkill({ ...skill, playerId });
  };

  return (
    <div className="container card" style={{ width: '90%', marginTop: '2rem' }}>
      <h2 className="mb-4">{category} Skills</h2>

      {skills.map((skill, index) => (
        <div
          key={index}
          className="flex-row"
          style={{
            justifyContent: 'space-between',
            padding: '0.75rem 0',
            borderBottom: '1px solid #E5E7EB',
            alignItems: 'center'
          }}
        >
          <div className="flex-row" style={{ alignItems: 'center', gap: '0.75rem' }}>
            {/* Status Circle */}
            <div
              style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: skill.completed ? '#10B981' : '#EF4444',
                flexShrink: 0
              }}
            ></div>
            <span>{skill.name}</span>
          </div>

          <button className="btn-primary" onClick={() => openSkillModal(skill)}>
            Details
          </button>
        </div>
      ))}

      {selectedSkill && (
        <SkillDetailsModal
          skill={selectedSkill}
          onClose={() => setSelectedSkill(null)}
          onSkillUpdated={onSkillUpdated}
        />
      )}
    </div>
  );
};

export default SkillChecklistComponent;
